<div class="tam-contact-control contact-alias" #aliasInput>
    <tag-input class="form-control item-value item-alias item-tag-input" theme="foundation-theme"
        [(ngModel)]='aliasArray' [addOnBlur]='true' name="alias" [style.width.px]="childConfig.css.width"
        [secondaryPlaceholder]="'Use \'Enter\' to input multiple values'" [placeholder]=""
        (ngModelChange)="textChange($event)">
    </tag-input>
    <label [hidden]="!hintContent" class="item-label-error">
        {{hintContent}}
    </label>
</div>